var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 60,
    viewBox: "0 0 82 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38768 0H75.6123C79.1775 0 82 2.91771 82 6.43391V53.5661C82 57.1571 79.1033 60 75.6123 60H6.38768C2.89674 60 0 57.1571 0 53.5661V6.43391C0 2.84289 2.89674 0 6.38768 0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.942 12.7974H50.9238V47.299H29.942V12.7974Z",
    fill: "#F4824A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0898 30.0482C32.0898 23.3365 35.1738 16.9575 40.4055 12.7974C30.9884 5.30908 17.2759 6.97314 9.84144 16.4583C2.40695 25.9435 4.05907 39.8107 13.5312 47.299C21.4613 53.567 32.5855 53.567 40.4605 47.299C35.1738 43.1388 32.0898 36.7599 32.0898 30.0482V30.0482Z",
    fill: "#E2574C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7055 30.0482C75.7055 42.1958 65.903 51.9584 53.8977 51.9584C48.9965 51.9584 44.3155 50.2943 40.4606 47.2435C49.9327 39.7552 51.5848 25.9435 44.1503 16.4028C43.1039 15.0161 41.8373 13.7958 40.4606 12.6864C49.9327 5.1981 63.6452 6.86217 71.0796 16.4028C74.0534 20.3411 75.6505 25.1114 75.7055 30.0482Z",
    fill: "#F4B459"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/MASTERCARD.b29269c82ba3d8d366bc73971130a35f.svg";
export { ForwardRef as ReactComponent };